/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "./SessionProvider.jsx";

// Supabase auto-detects the session in the URL (detectSessionInUrl: true).
// We just wait for it to materialize, then send the user onward.
export default function MagicLinkCallback() {
  const { loading, user } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    navigate(user ? "/" : "/login", { replace: true });
  }, [loading, user, navigate]);

  return <p className="muted">Signing you in...</p>;
}
